import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Setting} from '../models/setting';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'setting-editor-form',
  template: `
    <form (ngSubmit)="save()">
      <fieldset>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group"
                 [ngClass]="{'has-error':!settingForm.controls['title'].valid && settingForm.controls['title'].touched}">
              <label>Title*</label>
              <input class="form-control form-control-sm"
                     name="title"
                     [ngModel]="title"
                     [formControl]="settingForm.controls['title']"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group"
                 [ngClass]="{'has-error':!settingForm.controls['value'].valid && settingForm.controls['value'].touched}">
              <label>Value*</label>
              <input class="form-control form-control-sm" name="value"
                     [ngModel]="value"
                     [formControl]="settingForm.controls['value']"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Description</label>
              <textarea class="form-control form-control-sm"
                        rows="3"
                        name="description"
                        [ngModel]="description"
                        [formControl]="settingForm.controls['description']"></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <div class="form-group">
              <button class="btn btn-sm btn-outline-primary" [disabled]="working">
                <span *ngIf="working && setting.title">Saving</span>
                <span *ngIf="!working || (working && !setting.title)">Save</span>
              </button>
              <a *ngIf="!settingId" routerLink="../" class="btn btn-sm btn-outline-danger">Cancel</a>
              <a *ngIf="settingId" routerLink="../../" class="btn btn-sm btn-outline-danger">Cancel</a>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
  `,
  styles: []
})
export class SettingEditorFormComponent {
  @Input() setting: Setting;
  @Input() working: boolean;
  @Output() saveSetting: EventEmitter<Setting> = new EventEmitter();

  public settingForm: FormGroup;

  constructor(fb: FormBuilder) {
    this.settingForm = fb.group({
      'title': [null, Validators.required],
      'value': [null, Validators.required],
      'description': [null]
    });
  }

  get title() {
    return this.setting.title;
  }

  get value() {
    return this.setting.value;
  }

  get description() {
    return this.setting.description;
  }

  get settingId() {
    return this.setting.id;
  }

  save() {
    if (!this.settingForm.valid) {
      this.settingForm.controls['title'].markAsTouched();
      this.settingForm.controls['value'].markAsTouched();
      return;
    }
    const stg = this.settingForm.value as Setting;
    stg.id = this.settingId;
    stg.user = 'System';
    this.saveSetting.emit(stg);
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/setting-editor-form.ts